// Chain configurations for the confidential tokens application
export const CHAINS = {
    arbitrum: {
        id: 'arbitrum',
        name: 'Arbitrum',
        symbol: 'ARB',
        chainId: '0x66eee', // 421614 in hex (Arbitrum Sepolia)
        chainIdDecimal: 421614,
        rpcUrl: process.env.REACT_APP_ARBITRUM_RPC_URL || 'https://sepolia-rollup.arbitrum.io/rpc',
        blockExplorerUrl: process.env.REACT_APP_ARBITRUM_BLOCK_EXPLORER || 'https://sepolia.arbiscan.io',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/arbitrum.png', // Arbitrum icon
        color: '#28A0F0',
        active: true, // Currently supported
        contractAddress: process.env.REACT_APP_ARBITRUM_CONTRACT_ADDRESS || '0x30bAc8a17DCACbA7f70F305f4ad908C9fd6d3E2E',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_ARBITRUM_USDC_ADDRESS || '0x739423D770D76e54fE5cce1db09016c69916f6bB',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_ARBITRUM_USDT_ADDRESS || '0x2367dDf156601b411479A3745B20f0618055270E',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    ethereum: {
        id: 'ethereum',
        name: 'Ethereum Sepolia',
        symbol: 'ETH',
        chainId: '0xaa36a7', // 11155111 in hex (Ethereum Sepolia)
        chainIdDecimal: 11155111,
        rpcUrl: process.env.REACT_APP_ETHEREUM_RPC_URL || 'https://ethereum-sepolia-rpc.publicnode.com',
        blockExplorerUrl: process.env.REACT_APP_ETHEREUM_BLOCK_EXPLORER || 'https://sepolia.etherscan.io',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/ethereum.png',
        color: '#627EEA',
        active: true, // Now active
        contractAddress: process.env.REACT_APP_ETHEREUM_CONTRACT_ADDRESS || '0xAf061ec27494a9Cc1fE052642E25aCF99a94eCE0', // Gateway contract address to be set
        tokens: {
            usdc: {
                address: process.env.REACT_APP_ETHEREUM_USDC_ADDRESS || '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
                faucetAddress: process.env.REACT_APP_ETHEREUM_USDC_FAUCET_ADDRESS || '0x81D0B89Fbf8f8593C41dfec17516BB583e8D47b8',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_ETHEREUM_USDT_ADDRESS || '0x7a7B410fc367B1Da3d9a50EC7BD6B0778a6B34f5',
                faucetAddress: process.env.REACT_APP_ETHEREUM_USDT_FAUCET_ADDRESS || '0xF4871c6eF4b78Fe98c3c9658C7F3BB8Fc4c301f2',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            },
            usdg: {
                address: process.env.REACT_APP_ETHEREUM_USDG_ADDRESS || '0xfBb2A78CceEb415b00300925e464C3E44E6e06b0',
                faucetAddress: process.env.REACT_APP_ETHEREUM_USDG_FAUCET_ADDRESS || '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDG',
                name: 'Global Dollar',
                icon: '/usdg.png',
                color: '#26A17B'
            }
        }
    },
    hyperevm: {
        id: 'hyperevm',
        name: 'HyperEVM',
        symbol: 'HYPE',
        chainId: '0x9a9', // Placeholder chainId
        chainIdDecimal: 2473,
        rpcUrl: process.env.REACT_APP_HYPEREVM_RPC_URL || 'https://rpc.hyperevm.com',
        blockExplorerUrl: process.env.REACT_APP_HYPEREVM_BLOCK_EXPLORER || 'https://explorer.hyperevm.com',
        nativeCurrency: {
            name: 'HyperEVM',
            symbol: 'HYPE',
            decimals: 18
        },
        icon: '/hyperevm.png',
        color: '#FF6B35',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_HYPEREVM_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    monad: {
        id: 'monad',
        name: 'Monad',
        symbol: 'MON',
        chainId: '0x9b1', // Placeholder chainId
        chainIdDecimal: 2481,
        rpcUrl: process.env.REACT_APP_MONAD_RPC_URL || 'https://rpc.monad.xyz',
        blockExplorerUrl: process.env.REACT_APP_MONAD_BLOCK_EXPLORER || 'https://explorer.monad.xyz',
        nativeCurrency: {
            name: 'Monad',
            symbol: 'MON',
            decimals: 18
        },
        icon: '/monad.png',
        color: '#9333EA',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_MONAD_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    plasma: {
        id: 'plasma',
        name: 'Plasma',
        symbol: 'PLASMA',
        chainId: '0x9c4', // Placeholder chainId
        chainIdDecimal: 2500,
        rpcUrl: process.env.REACT_APP_PLASMA_RPC_URL || 'https://rpc.plasma.network',
        blockExplorerUrl: process.env.REACT_APP_PLASMA_BLOCK_EXPLORER || 'https://explorer.plasma.network',
        nativeCurrency: {
            name: 'Plasma',
            symbol: 'PLASMA',
            decimals: 18
        },
        icon: '/plasma.png',
        color: '#14B8A6',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_PLASMA_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    base: {
        id: 'base',
        name: 'Base Sepolia',
        symbol: 'ETH',
        chainId: '0x14a34', // 84532 in decimal (Base Sepolia)
        chainIdDecimal: 84532,
        rpcUrl: process.env.REACT_APP_BASE_RPC_URL || 'https://sepolia.base.org',
        blockExplorerUrl: process.env.REACT_APP_BASE_BLOCK_EXPLORER || 'https://sepolia-explorer.base.org',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/base.png',
        color: '#0052FF',
        active: true, // Now active with provided addresses
        contractAddress: process.env.REACT_APP_BASE_CONTRACT_ADDRESS || '0x6ef18f3EFaBF510665ba76c87FD80f1271D70A53',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_BASE_USDC_ADDRESS || '0xc98642eEa0a2E5f102DC2d84B799927198797CcB',
                faucetAddress: process.env.REACT_APP_BASE_USDC_FAUCET_ADDRESS || '0xf559D0d5c6d36193345ffB5a164885BCA2C1d4f0',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_BASE_USDT_ADDRESS || '0x8828ae77C3419cE33783C5751373561F8b79ACBE',
                faucetAddress: process.env.REACT_APP_BASE_USDT_FAUCET_ADDRESS || '0x801050790018234895D167619B8a2C7af6EBc4de',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    bnb: {
        id: 'bnb',
        name: 'BNB Smart Chain Testnet',
        symbol: 'tBNB',
        chainId: process.env.REACT_APP_BNB_CHAIN_ID || '0x61', // 97 in hex (BNB Smart Chain Testnet)
        chainIdDecimal: Number(process.env.REACT_APP_BNB_CHAIN_ID_DECIMAL) || 97,
        rpcUrl: process.env.REACT_APP_BNB_RPC_URL || 'https://data-seed-prebsc-1-s1.bnbchain.org:8545',
        blockExplorerUrl: process.env.REACT_APP_BNB_BLOCK_EXPLORER || 'https://testnet.bscscan.com',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'tBNB',
            decimals: 18
        },
        icon: '/bnb.png',
        color: '#F0B90B',
        active: true,
        contractAddress: process.env.REACT_APP_BNB_CONTRACT_ADDRESS || '0x0000000000000000000000000000000000000000', // To be updated when deployed
        tokens: {
            usdc: {
                address: process.env.REACT_APP_BNB_USDC_ADDRESS || '0x0000000000000000000000000000000000000000',
                faucetAddress: process.env.REACT_APP_BNB_USDC_FAUCET_ADDRESS || '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            }
        }
    },
    noble: {
        id: 'noble',
        name: 'Noble',
        symbol: 'NOBL',
        chainId: '0x0', // Cosmos-based chain (no EVM chainId)
        chainIdDecimal: 0,
        rpcUrl: process.env.REACT_APP_NOBLE_RPC_URL || 'https://rpc.noblechain.io',
        blockExplorerUrl: process.env.REACT_APP_NOBLE_BLOCK_EXPLORER || 'https://mintscan.io/noble',
        nativeCurrency: {
            name: 'Noble',
            symbol: 'NOBL',
            decimals: 6
        },
        icon: '/noble.png',
        color: '#4C7DD1',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_NOBLE_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    stellar: {
        id: 'stellar',
        name: 'Stellar',
        symbol: 'XLM',
        chainId: '0x0',
        chainIdDecimal: 0,
        rpcUrl: process.env.REACT_APP_STELLAR_RPC_URL || '',
        blockExplorerUrl: process.env.REACT_APP_STELLAR_BLOCK_EXPLORER || 'https://stellar.expert/explorer/testnet',
        nativeCurrency: {
            name: 'Lumen',
            symbol: 'XLM',
            decimals: 7
        },
        icon: '/stellar.png',
        color: '#7D00FF',
        active: true,
        contractAddress: process.env.REACT_APP_STELLAR_CONTRACT_ADDRESS || '',
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    arc: {
        id: 'arc',
        name: 'Arc',
        symbol: 'ARC',
        chainId: process.env.REACT_APP_ARC_CHAIN_ID || '0x4CEF52', 
        chainIdDecimal: Number(process.env.REACT_APP_ARC_CHAIN_ID_DECIMAL) || 5042002,
        rpcUrl: process.env.REACT_APP_ARC_RPC_URL || 'https://rpc.testnet.arc.network',
        blockExplorerUrl: process.env.REACT_APP_ARC_BLOCK_EXPLORER || 'https://testnet.arcscan.app',
        nativeCurrency: {
            name: 'USDC',
            symbol: 'USDC',
            decimals: 6
        },
        icon: '/arc.png',
        color: '#6C5CE7',
        active: true,
        contractAddress: process.env.REACT_APP_ARC_CONTRACT_ADDRESS || '0x0000000000000000000000000000000000000000', // To be updated when deployed
        tokens: {
            usdc: {
                address: process.env.REACT_APP_ARC_USDC_ADDRESS || '0x3600000000000000000000000000000000000000',
                faucetAddress: process.env.REACT_APP_ARC_USDC_FAUCET_ADDRESS || 'https://faucet.circle.com/?_gl=1*h6h29y*_gcl_au*MTAxMTkyOTU0Ny4xNzYyODA2NjQ5',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_ARC_USDT_ADDRESS || '0xb9f5A4f5e0af148A9D2e751De2754Ff7950F34d4',
                faucetAddress: process.env.REACT_APP_ARC_USDT_FAUCET_ADDRESS || '0x78e913645e90844F7fCe185cDabb89CA0A158a71',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    stable: {
        id: 'stable',
        name: 'Stable',
        symbol: 'STABLE',
        chainId: process.env.REACT_APP_STABLE_CHAIN_ID || '0x899', // 2201 in hex
        chainIdDecimal: Number(process.env.REACT_APP_STABLE_CHAIN_ID_DECIMAL) || 2201,
        rpcUrl: process.env.REACT_APP_STABLE_RPC_URL || 'https://rpc.testnet.stable.xyz',
        blockExplorerUrl: process.env.REACT_APP_STABLE_BLOCK_EXPLORER || 'https://testnet.stablescan.xyz/',
        nativeCurrency: {
            name: 'gUSDT',
            symbol: 'gUSDT',
            decimals: 6
        },
        icon: '/stable.png',
        color: '#6366F1',
        active: true, // Active
        contractAddress: process.env.REACT_APP_STABLE_CONTRACT_ADDRESS || '0x5bBD7c8e2311184ccD2c895E0E5D809Ec4229BfD',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_STABLE_USDC_ADDRESS || '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_STABLE_USDT_ADDRESS || '0x78Cf24370174180738C5B8E352B6D14c83a6c9A9',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    solana: {
        id: 'solana',
        name: 'Solana',
        symbol: 'SOL',
        chainId: '0x0', // Solana doesn't use EVM chainId
        chainIdDecimal: 0,
        rpcUrl: process.env.REACT_APP_SOLANA_RPC_URL || 'https://api.mainnet-beta.solana.com',
        blockExplorerUrl: process.env.REACT_APP_SOLANA_BLOCK_EXPLORER || 'https://explorer.solana.com',
        nativeCurrency: {
            name: 'Solana',
            symbol: 'SOL',
            decimals: 9
        },
        icon: '/solana.png',
        color: '#14F195',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_SOLANA_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    tempo: {
        id: 'tempo',
        name: 'Tempo',
        symbol: 'TEMPO',
        chainId: process.env.REACT_APP_TEMPO_CHAIN_ID || '0xa5bf', // 42431 in hex
        chainIdDecimal: Number(process.env.REACT_APP_TEMPO_CHAIN_ID_DECIMAL) || 42431,
        rpcUrl: process.env.REACT_APP_TEMPO_RPC_URL || 'https://rpc.moderato.tempo.xyz',
        blockExplorerUrl: process.env.REACT_APP_TEMPO_BLOCK_EXPLORER || 'https://explore.testnet.tempo.xyz/',
        nativeCurrency: {
            name: 'USDC',
            symbol: 'USDC',
            decimals: 6
        },
        icon: '/tempo.png',
        color: '#6366F1',
        active: true, // Active testnet
        contractAddress: process.env.REACT_APP_TEMPO_CONTRACT_ADDRESS || '',
        // Fee tokens that can be used to pay transaction fees on Tempo
        feeTokens: [
            {
                address: '0x20c0000000000000000000000000000000000000',
                symbol: 'PathUSD',
                name: 'Path USD',
                decimals: 6
            },
            {
                address: '0x20c0000000000000000000000000000000000001',
                symbol: 'AlphaUSD',
                name: 'Alpha USD',
                decimals: 6
            },
            {
                address: '0x20c0000000000000000000000000000000000002',
                symbol: 'BetaUSD',
                name: 'Beta USD',
                decimals: 6
            },
            {
                address: '0x20c0000000000000000000000000000000000003',
                symbol: 'ThetaUSD',
                name: 'Theta USD',
                decimals: 6
            }
        ],
        tokens: {
            pathusd: {
                address: '0x20c0000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'PathUSD',
                name: 'Path USD',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            alphausd: {
                address: '0x20c0000000000000000000000000000000000001',
                decimals: 6,
                symbol: 'AlphaUSD',
                name: 'Alpha USD',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            betausd: {
                address: '0x20c0000000000000000000000000000000000002',
                decimals: 6,
                symbol: 'BetaUSD',
                name: 'Beta USD',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            thetausd: {
                address: '0x20c0000000000000000000000000000000000003',
                decimals: 6,
                symbol: 'ThetaUSD',
                name: 'Theta USD',
                icon: '/usdc.png',
                color: '#2775CA'
            }
        }
    },
    // Robinhood Chain mainnet (Arbitrum Orbit L2). Longbow vault share tokens
    // (e.g. lbcoreUSDG) only exist on this mainnet.
    robinhood: {
        id: 'robinhood',
        name: 'Robinhood Chain',
        symbol: 'ETH',
        chainId: '0x1237', // 4663 in hex
        chainIdDecimal: 4663,
        testnet: false,
        rpcUrl: process.env.REACT_APP_ROBINHOOD_RPC_URL || 'https://rpc.mainnet.chain.robinhood.com',
        blockExplorerUrl: process.env.REACT_APP_ROBINHOOD_BLOCK_EXPLORER || 'https://robinhoodchain.blockscout.com',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/robinhood.png',
        color: '#CCFF00',
        active: true,
        contractAddress: process.env.REACT_APP_ROBINHOOD_CONTRACT_ADDRESS || '0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168',
        tokens: {
            usdg: {
                address: process.env.REACT_APP_ROBINHOOD_USDG_ADDRESS || '0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168',
                decimals: 6,
                symbol: 'USDG',
                name: 'Global Dollar',
                icon: '/usdg.png',
                color: '#26A17B'
            },
            lbcoreusdg: {
                // Longbow Core USDG: Morpho Vault V2 share token lending USDG.
                address: process.env.REACT_APP_ROBINHOOD_LBCOREUSDG_ADDRESS || '0x026df18fbd2A7639089D0a16293383ec687A5Ca1',
                decimals: 18,
                symbol: 'lbcoreUSDG',
                name: 'Longbow Core USDG',
                icon: '/usdg.png',
                color: '#26A17B',
                yieldToken: true,
                underlyingSymbol: 'USDG',
                underlyingDecimals: 6,
                underlyingTokenId: 'usdg'
            }
        }
    }
};

// Well-known EVM chain IDs (decimal) -> human-readable names.
// Used as a fallback so chains that aren't in CHAINS still display a real name
// instead of a bare "Chain <id>" (e.g. 97 -> BNB Smart Chain Testnet).
export const KNOWN_CHAIN_NAMES = {
    1: 'Ethereum Mainnet',
    5: 'Goerli Testnet',
    10: 'OP Mainnet',
    56: 'BNB Smart Chain',
    97: 'BNB Smart Chain Testnet',
    137: 'Polygon',
    250: 'Fantom Opera',
    420: 'Optimism Goerli',
    2201: 'Stable Testnet',
    2473: 'HyperEVM',
    2481: 'Monad',
    2500: 'Plasma',
    4663: 'Robinhood Chain',
    5042002: 'Arc Testnet',
    8453: 'Base Mainnet',
    42161: 'Arbitrum One',
    42170: 'Arbitrum Nova',
    42431: 'Tempo Testnet',
    43113: 'Avalanche Fuji Testnet',
    43114: 'Avalanche C-Chain',
    59144: 'Linea',
    80001: 'Polygon Mumbai',
    80002: 'Polygon Amoy',
    84532: 'Base Sepolia',
    421614: 'Arbitrum Sepolia',
    534352: 'Scroll',
    11155111: 'Ethereum Sepolia',
    11155420: 'Optimism Sepolia'
};

// Well-known EVM chain IDs -> block explorer base URLs.
// Used when a tx's chainId is not in CHAINS (e.g. Arbitrum One while CHAINS.arbitrum is Sepolia).
export const KNOWN_CHAIN_EXPLORERS = {
    1: 'https://etherscan.io',
    10: 'https://optimistic.etherscan.io',
    56: 'https://bscscan.com',
    97: 'https://testnet.bscscan.com',
    137: 'https://polygonscan.com',
    4663: 'https://robinhoodchain.blockscout.com',
    8453: 'https://basescan.org',
    42161: 'https://arbiscan.io',
    42170: 'https://nova.arbiscan.io',
    84532: 'https://sepolia.basescan.org',
    421614: 'https://sepolia.arbiscan.io',
    11155111: 'https://sepolia.etherscan.io',
    11155420: 'https://sepolia-optimism.etherscan.io'
};

/**
 * Alternate networks for a logical CHAINS key (e.g. Arbitrum One while CHAINS.arbitrum is Sepolia).
 * Resolved by getChainById so decryption/RPC/explorer use the correct endpoints.
 * Access-control queries via getChainIdDecimalsForKey include these variants automatically.
 */
export const CHAIN_ID_NETWORKS = {
    1: {
        baseKey: 'ethereum',
        name: 'Ethereum Mainnet',
        chainId: '0x1',
        chainIdDecimal: 1,
        rpcUrl: process.env.REACT_APP_ETHEREUM_MAINNET_RPC_URL || 'https://ethereum-rpc.publicnode.com',
        blockExplorerUrl: process.env.REACT_APP_ETHEREUM_MAINNET_BLOCK_EXPLORER || 'https://etherscan.io'
    },
    56: {
        baseKey: 'bnb',
        name: 'BNB Smart Chain',
        chainId: '0x38',
        chainIdDecimal: 56,
        rpcUrl: process.env.REACT_APP_BNB_MAINNET_RPC_URL || 'https://bsc-dataseed.bnbchain.org',
        blockExplorerUrl: process.env.REACT_APP_BNB_MAINNET_BLOCK_EXPLORER || 'https://bscscan.com'
    },
    8453: {
        baseKey: 'base',
        name: 'Base Mainnet',
        chainId: '0x2105',
        chainIdDecimal: 8453,
        rpcUrl: process.env.REACT_APP_BASE_MAINNET_RPC_URL || 'https://mainnet.base.org',
        blockExplorerUrl: process.env.REACT_APP_BASE_MAINNET_BLOCK_EXPLORER || 'https://basescan.org'
    },
    42161: {
        baseKey: 'arbitrum',
        name: 'Arbitrum One',
        chainId: '0xa4b1',
        chainIdDecimal: 42161,
        rpcUrl: process.env.REACT_APP_ARBITRUM_ONE_RPC_URL || 'https://arb1.arbitrum.io/rpc',
        blockExplorerUrl: process.env.REACT_APP_ARBITRUM_ONE_BLOCK_EXPLORER || 'https://arbiscan.io'
    }
};

// Normalize a chainId (number, decimal string, or hex string like "0x61") to a decimal number.
export const normalizeChainId = (chainId) => {
    if (chainId == null || chainId === '') return null;
    if (typeof chainId === 'number') return Number.isFinite(chainId) ? chainId : null;
    const raw = String(chainId).trim();
    const parsed = /^0x/i.test(raw) ? parseInt(raw, 16) : parseInt(raw, 10);
    return Number.isNaN(parsed) ? null : parsed;
};

// Resolve a display name for any chainId: prefer configured chains, then the
// well-known registry, and only fall back to "Chain <id>" for truly unknown ids.
export const getChainDisplayName = (chainId, chainKeyHint = null) => {
    const configured = getChainById(chainId, chainKeyHint);
    if (configured?.name) return configured.name;

    const decimal = normalizeChainId(chainId);
    if (decimal != null && KNOWN_CHAIN_NAMES[decimal]) {
        return KNOWN_CHAIN_NAMES[decimal];
    }
    return decimal != null ? `Chain ${decimal}` : `Chain ${chainId}`;
};

// Resolve a display name from an API / Firestore request object (uses chainKey hint).
export const getChainDisplayNameForRequest = (request) => {
    if (!request) return 'Unknown Chain';
    const hint =
        request.chainKey ??
        request.chain_key ??
        request.chain ??
        request.network;
    return getChainDisplayName(request.chainId, hint);
};

// Helper function to get active chains
export const getActiveChains = () => {
    return Object.values(CHAINS).filter(chain => chain.active);
};

/**
 * All numeric chainIds that belong to a logical CHAINS key (primary + CHAIN_ID_NETWORKS variants).
 * Used for access-control query filters so e.g. "arbitrum" includes both Sepolia and One.
 */
export const getChainIdDecimalsForKey = (chainKey) => {
    const chain = chainKey ? CHAINS[chainKey] : null;
    if (!chain || chain.chainIdDecimal == null) return [];
    const ids = [chain.chainIdDecimal];
    Object.values(CHAIN_ID_NETWORKS).forEach((variant) => {
        if (variant.baseKey === chainKey && variant.chainIdDecimal != null) {
            ids.push(variant.chainIdDecimal);
        }
    });
    return ids;
};

// Helper function to get chain by ID
// chainKeyHint: slug from storage (e.g. chainKey / chain) when chainIdDecimal is ambiguous (multiple chains use 0).
export const getChainById = (chainId, chainKeyHint = null) => {
    const decimal = normalizeChainId(chainId);
    // Prefer exact network variant (Arbitrum One vs Sepolia) when chainId is known.
    if (decimal != null && CHAIN_ID_NETWORKS[decimal]) {
        const variant = CHAIN_ID_NETWORKS[decimal];
        const base = CHAINS[variant.baseKey];
        if (base) {
            const { baseKey: _baseKey, ...network } = variant;
            return { ...base, ...network, id: base.id };
        }
    }

    const hintRaw =
        chainKeyHint != null && String(chainKeyHint).trim() !== ''
            ? String(chainKeyHint).toLowerCase().trim()
            : '';
    if (hintRaw && CHAINS[hintRaw]) {
        const byKey = CHAINS[hintRaw];
        const idMatches =
            chainId == null ||
            byKey.chainId === chainId ||
            byKey.chainId == chainId ||
            byKey.chainIdDecimal == chainId ||
            (decimal != null && byKey.chainIdDecimal === decimal);
        if (idMatches) return byKey;
    }
    return Object.values(CHAINS).find(
        (chain) =>
            chain.chainId === chainId ||
            chain.chainIdDecimal === chainId ||
            (decimal != null && chain.chainIdDecimal === decimal)
    );
};

/** Resolve chain from API / Firestore document (uses chainKey when numeric chainId is shared). */
export const getChainForRequest = (request) => {
    if (!request) return null;
    const hint =
        request.chainKey ??
        request.chain_key ??
        request.chain ??
        request.network;
    return getChainById(request.chainId, hint);
};

/** Stable logical id for grouping (e.g. stellar vs noble when both chainId === 0). */
export const getLogicalChainKey = (request) => {
    const chain = getChainForRequest(request);
    if (chain?.id) return chain.id;
    return String(request?.chainId ?? '');
};

/** Block explorer URL for a transaction hash (EVM /tx/… vs Stellar expert, etc.). */
export const getExplorerTransactionUrl = (chain, txHash) => {
    if (!chain || !txHash) return '#';
    const hash = String(txHash).trim();
    if (chain.id === 'stellar') {
        const base = (chain.blockExplorerUrl || 'https://stellar.expert/explorer/testnet').replace(/\/$/, '');
        return `${base}/tx/${encodeURIComponent(hash)}`;
    }
    const base = (chain.blockExplorerUrl || '').replace(/\/$/, '') || 'https://sepolia.etherscan.io';
    return `${base}/tx/${hash}`;
};

/** Explorer URL from an API / Firestore request; falls back to known chain explorers. */
export const getExplorerTransactionUrlForRequest = (request) => {
    if (!request?.transactionHash) return '#';
    const chain = getChainForRequest(request);
    if (chain) return getExplorerTransactionUrl(chain, request.transactionHash);

    const decimal = normalizeChainId(request.chainId);
    const explorerBase = decimal != null ? KNOWN_CHAIN_EXPLORERS[decimal] : null;
    if (!explorerBase) return '#';
    const hash = String(request.transactionHash).trim();
    return `${explorerBase.replace(/\/$/, '')}/tx/${hash}`;
};

// Helper function to get popular chains
export const getPopularChains = () => {
    const chainOrder = ['tempo', 'arbitrum', 'ethereum', 'base', 'robinhood', 'bnb', 'stable', 'arc', 'hyperevm', 'monad', 'plasma', 'noble', 'stellar', 'solana'];
    return chainOrder.map(id => CHAINS[id]).filter(Boolean);
};

// Helper function to get all tokens across all chains
export const getAllTokens = () => {
    const allTokens = {};
    Object.values(CHAINS).forEach(chain => {
        Object.entries(chain.tokens).forEach(([tokenId, token]) => {
            const key = `${chain.id}_${tokenId}`;
            allTokens[key] = {
                ...token,
                chainId: chain.id,
                chainName: chain.name,
                chainIcon: chain.icon,
                chainColor: chain.color
            };
        });
    });
    return allTokens;
};

// Helper function to get popular tokens (USDC, USDT, DAI across chains)
export const getPopularTokens = () => {
    const popularTokenSymbols = ['USDC', 'USDT', 'DAI', 'USDG', 'lbcoreUSDG'];
    const popularTokens = [];
    
    Object.values(CHAINS).forEach(chain => {
        Object.entries(chain.tokens).forEach(([tokenId, token]) => {
            if (popularTokenSymbols.includes(token.symbol)) {
                popularTokens.push({
                    ...token,
                    id: `${chain.id}_${tokenId}`,
                    chainId: chain.id,
                    chainName: chain.name,
                    chainIcon: chain.icon,
                    chainColor: chain.color,
                    chainActive: chain.active
                });
            }
        });
    });
    
    return popularTokens;
};
